var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1400_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H94V94H0V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.716 78.5533L31.9095 74.1999C33.2973 76.6605 34.5597 78.7424 37.5879 78.7424C40.4905 78.7424 42.3205 77.6069 42.3205 73.1904V43.1552H51.1541V73.3153C51.1541 82.4646 45.7911 86.6291 37.9665 86.6291C30.9 86.6291 26.798 82.9692 24.7158 78.5526",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9521 77.6067L63.1448 73.4422C65.0382 76.5343 67.4991 78.8057 71.8526 78.8057C75.5128 78.8057 77.8468 76.9757 77.8468 74.4517C77.8468 71.423 75.4492 70.3502 71.4108 68.584L69.203 67.6369C62.8297 64.9241 58.6019 61.5169 58.6019 54.3235C58.6019 47.6981 63.6497 42.65 71.5373 42.65C77.1532 42.65 81.1914 44.6063 84.0937 49.7173L77.2158 54.134C75.7014 51.421 74.0613 50.3485 71.5375 50.3485C68.9504 50.3485 67.3097 51.989 67.3097 54.134C67.3097 56.7842 68.9504 57.8571 72.7359 59.4978L74.9442 60.4442C82.453 63.6625 86.6807 66.9432 86.6807 74.3255C86.6807 82.2764 80.4341 86.6298 72.0421 86.6298C63.8393 86.6298 58.5389 82.7179 55.9523 77.6067",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1400_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.c6fcc8146fc41943e525b6ce42b2f3df.svg";
export { ForwardRef as ReactComponent };